import { useTranslation } from "react-i18next";
import { AreaStateAggregateType } from "@/routes/area-aggregate/types/area-state-aggregate.type";
import { useLockArea, useUnlockArea } from "@/api/areas/mutations";
import tw from "twin.macro";
import { toast } from "sonner";

function AreaLockSheetBody({
  areaStateAggregate,
  onDone,
}: {
  areaStateAggregate: AreaStateAggregateType;
  onDone: () => void;
}) {
  const { t: translator } = useTranslation();
  const { mutateAsync: lockArea, isPending: isLocking } = useLockArea({
    areaId: areaStateAggregate.areaId,
  });
  const { mutateAsync: unlockArea, isPending: isUnlocking } = useUnlockArea({
    areaId: areaStateAggregate.areaId,
  });

  const isBusy = isLocking || isUnlocking;

  return (
    <div tw="flex flex-col gap-4 px-6 pb-6">
      <p tw="text-lg text-gray-500">
        {areaStateAggregate.isLocked
          ? translator("area.endOfMaintenanceConfirmation1")
          : translator("area.underMaintenanceConfirmation1")}
      </p>
      <p tw="text-lg text-gray-500">
        {areaStateAggregate.isLocked
          ? translator("area.endOfMaintenanceConfirmation2")
          : translator("area.underMaintenanceConfirmation2")}
      </p>
      <div tw="flex gap-2 ">
        <button
          tw="border border-gray-200 bg-gray-50 active:bg-gray-200 transition transform duration-100 flex items-center justify-center w-12 h-12 rounded-xl shadow-md flex-1 h-fit p-2"
          onClick={onDone}
        >
          {translator("global.cancel")}
        </button>
        <button
          css={[
            tw`bg-yellow-400 active:bg-yellow-200 transition transform duration-100 flex items-center justify-center w-12 h-12 rounded-xl shadow-md flex-1 h-fit p-2`,
            tw`disabled:bg-yellow-200
              disabled:opacity-40
              disabled:cursor-not-allowed
              disabled:active:scale-100`,
          ]}
          disabled={isBusy}
          onClick={async () => {
            try {
              if (areaStateAggregate.isLocked) {
                await unlockArea();
              } else {
                await lockArea();
              }
            } catch (error) {
              toast.error("Erreur lors de la gestion de la maintenance");
            }
            onDone();
          }}
        >
          {translator("global.confirm")}
        </button>
      </div>
    </div>
  );
}

export default AreaLockSheetBody;
